import React from "react";
import { t } from "ttag";

import Trans from "../../../common/Trans";
import { strings } from "../../../localization";
import { useAppDispatch } from "../../reducers";
import { closeModal } from "../reducers";

import styles from "./index.module.scss";

export const FinancingFullExistingCardholder = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const cardName = strings.get("FINANCING_CARD_NAME");
    return (
        <div className={styles.wrapper}>
            <h3 className={styles.title}>
                <Trans
                    fmtString={t`Thank you for your interest in the ${cardName}.`}
                    data={{
                        SUP: (content) => <sup key={1}>{content}</sup>,
                    }}
                />
            </h3>
            <p>
                <Trans
                    fmtString={t`Our systems indicate that you have an existing Fortiva Retail Credit account. To view your credit card number, please visit <A>www.myfortiva.com/my-account</A> and click “View Virtual Card.”`}
                    data={{
                        A: (content) => (
                            <a
                                href="https://www.myfortiva.com/my-account"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {content}
                            </a>
                        ),
                    }}
                />
            </p>
            <button
                className="button"
                onClick={(e) => {
                    e.preventDefault();
                    dispatch(closeModal());
                }}
            >
                {t`Return to Shopping`}
            </button>
        </div>
    );
};
